export enum BankAccountModalityEnum {
    CURRENT_ACCOUNT = 'CURRENT_ACCOUNT',
    SAFE = 'SAFE',
    INVESTMENT = 'INVESTMENT',
}
